// extracted by mini-css-extract-plugin
module.exports = {"container":"e_2o","buttonPrev":"e_3o","buttonNext":"e_4o","hidden":"e_5o","iconPrev":"e_6o","iconNext":"e_7o","scrollView":"e_8o","card":"e_9o","scroller":"e_-o"};